import React, { Component } from 'react';
import './Scene.css';
import Hand from './view/Hand';
import Champion from './view/Champion';
import Enemies from './view/Enemies';
import Entity from './view/Entity';
import Court from './view/Court';
import Hero from './view/Hero';
import Room from './view/Room';
import Reward from './view/Reward';
import LevelUp from './view/LevelUp';
import Campfire from './view/Campfire';
import CardSelector from './view/CardSelector';
import CardDropper from './view/CardDropper';
import MapViewer from './view/MapViewer';
import DeckViewer from './view/DeckViewer';
import Choosebox from './view/Choosebox';
import Cutscene from './view/Cutscene';
import RotateMessage from '../components/utility/RotateMessage';

import { createStore } from 'redux';
import reducers from './reducers';
import { Tooltip } from 'reactstrap';

import Lightbox from '../components/utility/Lightbox';
import SceneButton from '../components/buttons/SceneButton';
import MainButton from '../components/buttons/MainButton';
import Card from '../components/cards/Card';
import Ability from '../components/cards/Ability';
import CardBox from '../components/cards/CardBox';
import Sequencer from './Sequencer';
import Logs from './Logs';
import Error from '../components/home/Error';
import Back from '../components/Back';

import PlayingState from './controller/PlayingState';
import WaitingState from './controller/WaitingState';
import HandChoiceState from './controller/HandChoiceState';
//import MovingState from './controller/state/MovingState';

import { read, getLanguage } from '../TextManager';
import { play, preload, stopMusic, stopCategory } from '../SoundManager';
import CutsceneManager from './CutsceneManager';

import Library from './utility/Library';
import User from '../User';
import Img from '../StableImage';
import milestones from '../library/milestones.json';

import Run from './model/Run';
import Broadcaster from './Broadcaster';

const lang = getLanguage();
const statuses = Object.values(Library.statuses);
const ZEN_MILESTONE_IMAGE = "https://moa-pull.b-cdn.net/assets/ui/zen%20milestone.png";

const tooltipEffect = effect => {
  const curseEffects = [];
  const text = effect.replace(/\[([^\]]+)\]/g, (_, label) => {
    const statusName = label.split('/')[0];
    const status = statuses.find(candidate => candidate.translations?.en?.name === statusName);
    const curseEffect = status?.type === "curse" && status.translations?.[lang]?.effect;

    if (curseEffect && !curseEffects.includes(curseEffect))
      curseEffects.push(curseEffect);
    return label;
  });

  return <>{text}{curseEffects.map((curseEffect, index) => <React.Fragment key={index}> <i>({curseEffect})</i></React.Fragment>)}</>;
};

const backgrounds = [
  "floor1",
  "floor2",
  "floor3",
  "floor4",
  "floor5"
]

const audio = [
  "Tenno - The Guiding Wind",
  "BVG - Gilded Voyage",
  "Tenno - Sacred Tree",
  "Tenno - Between Worlds",
  "BVG - Sacred Land"
]

function actForRun(run) {

  return Library.getAct(run?.act) || Object.values(Library.acts).find(act => act.act === run?.floor);
}

function backgroundForRun(run) {

  return run?.background ?? actForRun(run)?.background ?? backgrounds[(run?.floor || 1)-1];
}

function themeForRun(run) {

  return run?.audio || actForRun(run)?.theme || audio[(run?.floor || 1)-1];
}

function hasUniqueEnabledCards(run) {

  const cards = run?.deck?.filter(card => card.status !== "disabled" && !card.card.locked) || [];
  return new Set(cards.map(card => card.card.key)).size === cards.length;
}

export default class Scene extends Component {
	
  constructor (props) {

    super(props);

    this.updating = false;

    this.store = createStore(reducers);
    this.store.subscribe(() => {
      if (this.updating)
        return;
      this.updating = true;
      setTimeout(() => {
        this.updating = false;
        this.setState({model: this.store.getState()}, () => { if (this.sequencer.resume) this.sequencer.resume(); });
      })
    });

    this.checkAudio = () => {

      if (this.audioPlaying && !this.cutsceneManager.cutscene)
        play(themeForRun(this.run), "music");
    }

    this.handleKeyDown = (event) => {

      if (event.key === 'M' || event.key === 'm') {
        this.setState({mapviewer: this.state.mapviewer ? null : this.state.model.deck})
      }

      if (event.key === 'D' || event.key === 'd') {
        if (this.run.canCloseDeckbuilder)
          this.setState({deckviewer: this.state.deckviewer ? null : this.state.model.deck, deckvieweredit: this.state.deckviewer ? false : true})
      }
    }

    this.handlePotionActionOutside = (event) => {

      if (this.state?.potionAction == null)
        return;
      if (event.target.closest?.('.potion-action-wrapper'))
        return;
      this.setState({potionAction: null});
    }

    document.addEventListener('click', this.checkAudio, { once: true });
    document.addEventListener('keydown', this.checkAudio, { once: true });

    this.volume = 1;
    //this.noPlayer = 0;
    this.controller = new WaitingState(this);
    this.sequencer = new Sequencer(this, n => this.store.dispatch(n));

    this.cutsceneManager = new CutsceneManager(this, c => this.cutscene(c));

    //let decks = JSON.parse(localStorage.getItem('decks'))
    //let activedeck = decks.filter(deck => deck.key.toString() === localStorage.getItem('activedeck'))[0].body;
    //this.io.gamemode('room', activedeck);

    let broadcaster = new Broadcaster();

    this.event = JSON.parse(localStorage.getItem("run.event"));
    if (this.event && this.event.memory)
      this.cutsceneManager.deactivate();
    let save = User.currentRun;
    this.run = null;
    if (save) {
      this.run = Run.build(save, broadcaster);
      setTimeout(() => {
        let savelog = User.getItem("run.log");
        if (savelog)
          broadcaster.log = JSON.parse(savelog);
        if (this.run?.room?.fight?.choosingHand)
          this.controller = new HandChoiceState(this, this.run.room.fight);
        else if (this.run?.room?.fight?.turn === "player")
          this.controller = new PlayingState(this, this.run.room.fight);
        else
          this.controller = new WaitingState(this);
        this.run.notify('gamestate', this.run.serialize(), broadcaster.log);
      }, 10);
    } else if (!this.event) {
      this.run = new Run();
      setTimeout(() => {
        this.run.notify('newrun', this.run, this.run.champion.model.key);
        /*if (this.event) {
          this.run.notify('gamestate', this.run.serialize());
          this.run.newFloor();
          this.run.notify("startrun", this.run);
        }
        else*/
          this.run.start();
      }, 10);
    } else if (this.event) {
      this.run = new Run();
      setTimeout(() => {
        this.run.notify('newrun', this.run, this.run.champion.model.key);
        this.run.notify('gamestate', this.run.serialize());
        this.run.newFloor();
        this.run.notify("startrun", this.run);
        this.run.startStoryEvent (this.event.enemies, this.event.background, this.event.audio, this.event.minDeckSize, this.event.memory);
      }, 10);
    }
    
    this.didLoad = save !== null && save !== undefined;
    if (!save) {
      if (this.event) {

        this.run.init(broadcaster, User.champion, User.difficulty, {
          startingLevel: this.event.startingLevel || User.dataFor(User.champion, User.difficulty).level,
          deck: this.event.deck,
          relics: this.event.relics,
          companion: this.event.companion,
          power: this.event.power || 1
        });
      } else {

        let floor = localStorage.getItem("run.floor") || 1;
        floor = Math.min(Math.max(User.data.level-1, 1), floor);
        localStorage.removeItem("run.floor");
        this.run.init(broadcaster, User.champion, User.difficulty, floor);
      }
    }
    broadcaster.start(this);
    
    const startsInDeckEdit = this.run.deckSize < this.run.minDeckSize;

    this.grabbing = null;
    this.dragged = React.createRef();
    this.startTime = Date.now(); // Record the start time when the component mounts
    //this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
    this.state = {
      model: this.store.getState(),
      focus:null,
      casting: null,
      tooltip: null, 
      deckviewer: startsInDeckEdit ? this.run.deck : null,
      deckvieweredit: startsInDeckEdit,
      mapviewer: false
    }
    
    audio.forEach(track => preload(track));
  }

  componentWillUnmount () {

    window.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('pointerdown', this.handlePotionActionOutside);
    stopMusic();

    //this.handleBeforeUnload();
    //document.removeEventListener('beforeunload', this.handleBeforeUnload);
    document.removeEventListener('click', this.checkAudio);
    document.removeEventListener('keydown', this.checkAudio);
  }

  /*handleBeforeUnload() {

    const endTime = Date.now();
    const timeSpent = endTime - this.startTime;
    if (this.run)
      User.addStats(this.run.difficultySetting, "timePlayed", this.run.champion.model.key, Math.floor(timeSpent / 60000));
  }*/

  componentDidMount() {

    //window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('pointerdown', this.handlePotionActionOutside);
  }

  save () {

    if (this.run.over || this.run.fight?.choosingHand)
      return;
    User.setItem("run.save", JSON.stringify(this.run.serialize()));
    User.setItem("run.log", JSON.stringify(this.run.broadcaster.log));
  }

  get playing () { return this.controller.name === "playing" }
  get targeting () { return (this.controller.name === "playing" && this.controller.selected && this.controller.selected.hasTarget ? this.controller.selected : null) }
  get waiting () { return this.controller.name === "waiting" }
  get choosing () { return this.controller.name === "choosing" }

  getMilestoneImage (milestone, imageIndex=this.getMilestoneImageIndex(milestone)) {

    if (this.isZenMilestoneImage(milestone, imageIndex))
      return ZEN_MILESTONE_IMAGE;
    if (Array.isArray(milestone.img))
      return milestone.img[imageIndex] || null;
    return milestone.img;
  }

  isGlobalMilestone (milestone) {

    return User.isGlobalMilestone(milestone.key);
  }

  getMilestoneImageIndex (milestone) {

    if (this.isGlobalMilestone(milestone))
      return Array.isArray(milestone.img) ? 0 : null;

    const unlocked = User.checkMilestone(milestone.key);
    if (unlocked < 2)
      return null;
    return Math.min(unlocked - 2, Array.isArray(milestone.img) ? milestone.img.length - 1 : 0);
  }

  getUnlockedMilestoneImageIndexes (milestone) {

    if (this.isGlobalMilestone(milestone))
      return Array.isArray(milestone.img) && milestone.img[0] ? [0] : [];

    const unlocked = User.checkMilestone(milestone.key);
    if (!Array.isArray(milestone.img) || unlocked < 2)
      return [];
    return milestone.img.map((_, i) => i).filter(i => i <= unlocked - 2 && milestone.img[i]);
  }

  getMilestoneDifficulty (milestone, imageIndex) {

    if (this.isGlobalMilestone(milestone))
      return null;

    if (User.checkMilestone(milestone.key) === 1 || imageIndex === null || imageIndex === undefined)
      return "zen";
    return ["casual", "challenge", "hardcore"][imageIndex];
  }

  isZenMilestoneImage (milestone, imageIndex=this.getMilestoneImageIndex(milestone)) {

    return !this.isGlobalMilestone(milestone) && this.getMilestoneDifficulty(milestone, imageIndex) === "zen";
  }

  getNextMilestoneImageIndex (imageIndexes, imageIndex) {

    if (!imageIndexes || imageIndexes.length <= 1)
      return null;
    const imagePosition = imageIndexes.findIndex(i => i === imageIndex);
    if (imagePosition < 0)
      return imageIndexes[0];
    return imageIndexes[(imagePosition + 1) % imageIndexes.length];
  }

  getDifficultyName (difficulty) {

    switch (difficulty) {
    case "zen": return "Zen";
    case "casual": return "Casual";
    case "challenge": return "Challenge";
    case "hardcore": return "Hardcore";
    default: return "";
    }
  }

  unlockLevelMilestone () {

    const championKey = this.run.champion.model.key;
    const milestone = Object.values(milestones[championKey] || {}).find(ms => ms.check && ms.check.level === this.run.champion.level);
    const unlockedMilestone = milestone && User.unlockMilestone(milestone.key, this.run.difficultySetting);

    if (!unlockedMilestone)
      return;

    const unlock = {
      type: "milestone",
      milestone: unlockedMilestone,
      text: unlockedMilestone.title || unlockedMilestone.requirement
    };

    setTimeout(() => {
      const unlocks = this.state.unlocks && this.state.unlocks.length > 0 ? this.state.unlocks.concat(unlock) : [unlock];
      this.setState({unlocks});
    }, 1500);
    this.canSelectUnlock = false;
    setTimeout(() => this.canSelectUnlock = true, 100);
  }

  queueMilestoneUnlock (unlockedMilestone, delay=0) {

    if (!unlockedMilestone || typeof unlockedMilestone !== "object")
      return;

    const unlock = {
      type: "milestone",
      milestone: unlockedMilestone,
      text: unlockedMilestone.title || unlockedMilestone.requirement
    };

    const addUnlock = () => {
      this.setState(state => ({
        unlocks: state.unlocks && state.unlocks.length > 0 ? state.unlocks.concat(unlock) : [unlock]
      }));
    };

    if (delay)
      setTimeout(addUnlock, delay);
    else
      addUnlock();
    this.canSelectUnlock = false;
    setTimeout(() => this.canSelectUnlock = true, 100);
  }

  unlockStoryMilestone () {

    const championKey = this.run.champion.model.key;
    const progress = User.dataFor(championKey, this.run.difficultySetting).progress-1;
    const milestone = Object.values(milestones[championKey] || {}).find(ms => ms.check && ms.check.story === progress);
    const unlockedMilestone = milestone && User.unlockMilestone(milestone.key, this.run.difficultySetting);

    if (!unlockedMilestone)
      return;

    const unlock = {
      type: "milestone",
      milestone: unlockedMilestone,
      text: unlockedMilestone.title || unlockedMilestone.requirement
    };

    const unlocks = this.state.unlocks && this.state.unlocks.length > 0 ? this.state.unlocks.concat(unlock) : [unlock];
    this.setState({unlocks});
    this.canSelectUnlock = false;
    setTimeout(() => this.canSelectUnlock = true, 100);
  }

  unlockStageMilestone (stage) {

    const championKey = this.run.champion.model.key;
    const milestone = Object.values(milestones[championKey] || {}).find(ms => ms.check && ms.check.stage === stage);
    return milestone && User.unlockMilestone(milestone.key, this.run.difficultySetting);
  }

  notify (type, data) {

    this.cutsceneManager.event({type, data}, () => {
      this.sequencer.add({n: {type, data}, callback: () => this.actUponUpdate(type, data)}); 
    })
  }

  cutscene (c) {

    this.setState({cutscene: c ? Object.assign({}, this.state.cutscene, c) : null});
  }

  actUponUpdate (type, data) {

    switch (type) {
    case "gamestate":
    case "newfloor":
      if (!this.event) {
        this.audioPlaying = true;
        play(themeForRun(this.run), "music");
      }
      break;
    case "storyevent":
      this.audioPlaying = true;
      play(this.run.audio, "music");
      localStorage.removeItem("run.event");
      /*if (type === "newfloor" || !this.didLoad)
        this.setState({deckviewer: null, mapviewer: true})*/
      break;
    case "victory": {
      if (this.run.storyEvent && !this.run.memory) {
        User.progressStory(this.run.difficultySetting, this.run.champion.model.key);
        this.unlockStoryMilestone();
        /*let data = User.dataFor(this.run.champion.model.key, this.run.difficultySetting);
        if (data.maxLevel > data.level && data.maxLevel <= 10 && (this.run.champion.model.key !== 5 || data.maxLevel <= 6)) {
          this.setState({unlocks: [
            { type: "level", img: this.run.champion.img, text: read('scene/unlockgrowth').replace('[X]', data.maxLevel) }
          ]})
          this.canSelectUnlock = false;
          setTimeout(() => this.canSelectUnlock = true, 100);
        }*/
      } else if (!this.run.storyEvent && this.run.rooms.length > 1) {
        const undoRunHistory = User.addRun(this.run);
        undoRunHistory?.unlockedMilestones?.forEach(milestone => this.queueMilestoneUnlock(milestone));
      }
      if (this.run.convertedExpReward)
        User.setShards(this.run.data.shards + this.run.convertedExpReward, this.run.champion.model.key, this.run.difficultySetting);
      User.setBenevolence(this.run.data.benevolence + this.run.addedBenevolence, this.run.champion.model.key, this.run.difficultySetting);
      /*if (this.run.champion.level > this.run.data.level) {
        let unlocks = User.championGrowth(this.run.difficultySetting, this.run.champion.model.key, this.run.champion.level);
        if (unlocks.length > 0)
          this.setState({unlocks});
      }*/
      User.removeItem("run.save");
      User.removeItem("run.log");
      this.controller = new WaitingState(this);
      break;
    }
    case "gameover": {
      const championKey = this.run.champion.model.key;
      const difficulty = this.run.difficultySetting;
      const previousShards = Object.fromEntries(User.lowerOrEqualDifficulties(difficulty).map(diff => [diff, User.dataFor(championKey, diff).shards]));
      const previousBenevolence = User.dataFor(championKey, difficulty).benevolence;
      const undoRunHistory = !this.run.storyEvent && this.run.rooms.length > 1 ? User.addRun(this.run) : null;
      undoRunHistory?.unlockedMilestones?.forEach(milestone => this.queueMilestoneUnlock(milestone));

      if (!this.run.storyEvent && this.run.rooms.length > 1)
        this.undoRunStats = () => {
          if (undoRunHistory)
            undoRunHistory();
          Object.entries(previousShards).forEach(([diff, shards]) => User.setShards(shards, championKey, diff));
          User.setBenevolence(previousBenevolence, championKey, difficulty);
          this.undoRunStats = null;
        };
      else
        this.undoRunStats = () => {
          Object.entries(previousShards).forEach(([diff, shards]) => User.setShards(shards, championKey, diff));
          User.setBenevolence(previousBenevolence, championKey, difficulty);
          this.undoRunStats = null;
        };
      User.setShards(this.run.data.shards + this.run.deathShardReward, this.run.champion.model.key, this.run.difficultySetting);
      User.setBenevolence(this.run.data.benevolence + this.run.addedBenevolence, this.run.champion.model.key, this.run.difficultySetting);
      User.removeItem("run.save");
      User.removeItem("run.log");
      this.controller = new WaitingState(this);
      break;
    }
    case "continue":
      if (this.undoRunStats)
        this.undoRunStats();
      this.setState({tooltip: null});
      setTimeout(() => this.save(), 0);
      break;
    case "key":
      User.unlockStage(this.run.difficultySetting, this.run.champion.model.key);
      this.setState({unlocks: [
        { type: "stage", img: "/images/backgrounds/" + backgrounds[this.run.maxFloor] + ".png", text: read('scene/unlockstage').replace('[X]', this.run.maxFloor+1) }
      ]});
      this.canSelectUnlock = false;
      setTimeout(() => this.canSelectUnlock = true, 100);
      break;
    case "playerturn":
      this.save();
    case "chosehand":
      this.controller = new PlayingState(this, this.run.room.fight);
      break;
    case "mindecksize":
      if (!this.run.canCloseDeckbuilder && !(this.run.room.fight && this.run.room.model.difficulty === 4))
        this.setState({deckviewer: this.state.model.deck, deckvieweredit: true, tooltip: null})
      this.save();
      break;
    case "shopbuy":
      this.save();
      break;
    case "levelup":
      if (this.run.champion.level > this.run.data.level) { // level break
        //if (this.run.champion.levelbreak > this.run.data.level)
        User.championGrowth(this.run.difficultySetting, this.run.champion.model.key, this.run.champion.level);
        this.unlockLevelMilestone();
        /*let unlocks = [];
        let unlockedCards = Object.values(Library.cards).filter(card => card.champion === this.run.champion.model.key && card.level === this.run.champion.level);
        unlockedCards.forEach(card => unlocks.push({ type: "card", card, text: read('scene/unlockcard') }))
        if (unlocks.length > 0)
          setTimeout(() => {
            if (this.state.unlocks && this.state.unlocks.length > 0)
              unlocks = this.state.unlocks.concat(unlocks);
            this.setState({unlocks});
          }, 4500);
        if (this.run.data.maxLevel === this.run.data.level && this.run.data.level <= 6 && this.run.champion.model.key <= 4)
          unlocks.push({ type: "cutscene", img: "/images/cutscene.png", text: read('scene/unlocklegacyscene') })
        this.canSelectUnlock = false;
        setTimeout(() => this.canSelectUnlock = true, 100);*/
      }
      this.setState({tooltip: null});
      this.save();
      break;
    case "enterroom":
      if (data[0].type === "start") {
        const deckedit = !this.run.canCloseDeckbuilder;
        this.setState({deckviewer: deckedit ? this.state.model.deck : null, mapviewer: true, deckvieweredit: deckedit})
      }
      break;
      if (data[0].type === "altar") {
        this.audioPlaying = false;
        stopMusic();
      }
      this.setState({tooltip: null});
      this.save();
      break;
    case "addcard":
      if (!this.run.choosingCard)
        this.setState({deckviewer: this.state.model.deck, deckvieweredit: true, tooltip: null})
      this.save();
      break;
    case "newcardchoice":
    case "newcardbundle":
    case "campfire":
    case "pathchoices":
    case "fightreward":
    case "winfight":
    case "reroll":
    case "fillshop":
    case "enterroom":
    case "initroom":
    case "usefountain":
    case "taketreasure":
    case "dropcard":
    case "skipcardchoice":
    case "roomcollect":
    case "handchoiceresolve":
    case "setspirit":
    case "setchoices":
    case "duplicatecard":
    case "enablecard":
    case "lifegain":
    case "setplan":
    case "previewcelestial":
    case "usepotion":
    case "droppotion":
      this.setState({tooltip: null, potionAction: null, potionActionTouch: null});
      this.save();
      break;
    case "newcelestial": {
      const completedStage = this.run.floor < this.run.maxFloor ? this.run.floor : this.run.power + 2;
      this.queueMilestoneUnlock(data[3]);
      this.queueMilestoneUnlock(this.unlockStageMilestone(completedStage));
      this.setState({tooltip: null, potionAction: null, potionActionTouch: null});
      this.save();
      break;
    }
    case "potion":
    case "relic":
      this.setState({tooltip: null});
      break;
    case "endplayerturn":
      this.controller = new WaitingState(this);
      break;
    case "handchoice":
        this.controller = new HandChoiceState(this, this.run.room.fight);
      break;
    case "celestialupgrade":
      this.save();
      this.forceUpdate();
      break;
    default: break;
    }
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTouch = touch;
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  onSelectCard (e, card) {

    if (this.controller.selectCard) {
      this.controller.selectCard(card, e && e.pointerType === "touch");
      this.forceUpdate()
    }
  }

  onSelectSkill (e) {

    if (this.controller.selectSkill) {
      this.controller.selectSkill(e && e.pointerType === "touch");
      this.forceUpdate()
    }
  }

  onSelectEntity (e, entity) {

    if (this.controller.selectEntity)
      this.controller.selectEntity(entity);
  }

  endTurn () {

    if (this.controller.endTurn)
      this.controller.endTurn();
  }

  unselect () {

    if (this.controller && this.controller.unselect) {
      this.controller.unselect();
      this.setState({tooltip: null})
      this.forceUpdate();
    }
  }

  isPotionUsable (item) {

    if (item.unusable)
      return false;
    if (item.requirescurse && this.state.model.champion.curses.length === 0)
      return false;
    if (item.fight)
      return this.playing && this.state.model?.room?.fight && !this.state.model.room.fight.done && (!item.companion || this.state.model.companion);
    if (item.menagerie)
      return this.state.model?.room?.model.type === "menagerie";
    if (item.activefountain)
      return this.state.model?.room?.fountain && this.state.model.room.fountain.active;
    if (item.fountain)
      return this.state.model?.room?.fountain;
    if (item.mezurishop)
      return this.state.model?.room?.shop && this.state.model.room.shop.mezuri && (!item.bonus?.shopdiscount || !this.state.model.room.variables.discountedshop);
    if (item.shop)
      return !!this.state.model?.room?.shop;
    if (item.shop)
      return this.state.model?.room?.model.type === "shop";
    if (item.nextshop)
      return 16 - this.state.model.time < 15;
    if (item.relic)
      return (this.state.model?.room?.collectables.some(col => col && col.type === "relic") || this.state.model?.room?.treasure?.collectables.some(col => col && col.type === "relic")) && !this.state.model.room.shop;
    if (item.cardchoice)
      return this.state.model?.choosingCard;

    return true;
  }

  isRelicActive (relic) {

    switch (relic?.key) {
    case "masters-charm": return !!this.state.model.companion;
    case "prismatic-charm": return hasUniqueEnabledCards(this.state.model);
    case "abundance-charm": return this.state.model.deckSize >= this.state.model.minDeckSize + 6;
    default: return true;
    }
  }

	render () {

    if (this.state.model === 0)
      return (
      <div className="scene">
        {/*<div className="scene-background">
          <img src={"/images/backgrounds/" + backgrounds[0] + ".png"}/>
        </div>*/}
        {
          this.state.cutscene ?
          <Cutscene back={() => this.cutsceneManager.back()} skip={() => this.cutsceneManager.skip()} continue={() => this.cutsceneManager.continue()} src={this.state.cutscene}/> : ""
        }
      </div>);

    let premium = User.premium;
    let progress = this.run.data;
    const difficulty = this.state.model.difficultySetting || this.run.difficultySetting;
    const act = actForRun(this.state.model);
    const roomNumber = Math.max(1, Math.min(17, 17 - this.state.model.time))-1;
    const hasHeldPowerOrb = this.state.model.room?.type === "start" && this.state.model.room?.collectables.some(col => col?.type === "relic" && ["power-orb", "power-orb-2"].includes(col.value?.key));
    const hasTreasureBackdrop = this.state.model.room?.shop || (this.state.model.room?.treasure && this.state.model.room.treasure.collectables.some(col => col.type === "relic")) || (this.state.model.room?.treasure && this.state.model.room.treasure.type === "altar") || hasHeldPowerOrb;

		return (
      <div id="scene" className={"scene playing scene-champion-" + this.state.model.champion.model.key + (localStorage.getItem('options.slowmode') ? "" : " fastmode") + (this.state.model.over || this.state.model.win ? " scene-over" : "") + (this.state.model.droppingPotion ? " scene-drop-item" : "") + (this.state.model.droppingRelic ? " scene-drop-relic" : "")}>
        <RotateMessage/>
        <div className={"scene-background background-" + backgroundForRun(this.state.model) + (hasTreasureBackdrop ? " shop-background" : ((this.state.model.room?.celestial?.active) ? " spirit-background" : ""))} onClick={() => this.unselect()}>
          { this.state.model.deckbuilder ? "" : <Img key={"background-" + (this.state.model.deckbuilder ? "deckbuilder" : backgroundForRun(this.state.model))} src={"/images/backgrounds/" + (this.state.model.deckbuilder ? "deckbuilder" : backgroundForRun(this.state.model)) + ".png"}/> }
          <div className="background-particle"/><div className="background-particle"/><div className="background-particle"/><div className="background-particle"/>
        </div>
        <div className="champion-info">
          <div id="champion-level" onPointerDown={e => this.toggleTooltip("champion-level", e.pointerType === "touch")} className="champion-stat level">
            <Img src={"/images/level/" + this.state.model.champion.model.name + ".png"}/>
            <div className="stat-count">{this.state.model.champion.level}<span className="micro-stat-count">{"/ " + this.state.model.champion.maxLevel}</span></div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "champion-level"} target="champion-level" toggle={() => this.toggleTooltip("champion-level")}><b>{read('scene/level')}</b><br/>{Library.scalePassiveText(this.run.champion.model, this.run.champion.model.translations[lang].passive, this.run.champion.level).replace(/\[([^\]]+)\]/g, (_, keyword) => statuses.filter(s => s.translations && s.translations.en.name === keyword)[0].translations[lang].name)}</Tooltip>
          <div id="champion-health" onPointerDown={e => this.toggleTooltip("champion-health", e.pointerType === "touch")} className="champion-stat health">
            <Img src={"/images/health.png"}/>
            <div className="stat-count">{this.state.model.champion.hp}/{this.state.model.champion.maxhp}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "champion-health"} target="champion-health" toggle={() => this.toggleTooltip("champion-health")}><b>{read('scene/health')}</b><br/>{read('scene/healthinfo')}</Tooltip>
        </div>
        <div className="champion-info run-progress-info">
          {/*<div id="corruption" onPointerDown={() => this.toggleTooltip("corruption")} className="champion-stat corruption">
            <Img src="/images/corruption.png"/>
            <div className="stat-count">{this.state.model.champion.corruption}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "corruption"} target="corruption" toggle={() => this.toggleTooltip("corruption")}><b>Corruption</b><br/>No use in this update.</Tooltip>*/}
          <div id="gold" onPointerDown={e => this.toggleTooltip("gold", e.pointerType === "touch")} className="champion-stat gold">
            <Img src="/images/gold.png"/>
            <div className="stat-count">{this.state.model.champion.gold}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "gold"} target="gold" toggle={() => this.toggleTooltip("gold")}><b>{read('scene/gold')}</b><br/>{read('scene/goldinfo')}</Tooltip>
          <div id="hud-difficulty" onPointerDown={e => this.toggleTooltip("hud-difficulty", e.pointerType === "touch")} className="hud-indicator difficulty-indicator">
            <Img src={"/images/" + difficulty + ".png"}/>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "hud-difficulty"} target="hud-difficulty" toggle={() => this.toggleTooltip("hud-difficulty")}><b>Difficulty</b><br/>{this.getDifficultyName(difficulty)}</Tooltip>
          <div id="hud-act" onPointerDown={e => this.toggleTooltip("hud-act", e.pointerType === "touch")} className="champion-stat room-progress">
            <Img src={"/images/acts/" + (act?.key || "ruins") + ".png"}/>
            <div className="stat-count">{roomNumber}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "hud-act"} target="hud-act" toggle={() => this.toggleTooltip("hud-act")}><b>{act?.name || "Act"}</b><br/>{"Act " + (act?.act || this.state.model.floor) + " out of 3. Reach room 17 to fight a boss."}</Tooltip>
        </div>
        <div id="map-viewer-open" className={"map-viewer-open-wrapper info-viewer-open-wrapper" + (this.state.mapviewer ? " open" : "")}>
          <div className="map-viewer-open info-viewer-open" onClick={() => this.setState({mapviewer: this.state.mapviewer ? null : this.state.model.deck})}>
            <Img src="/images/map.png"/>
          </div>
        </div>
        <div id="deck-viewer-open" className={"deck-viewer-open-wrapper info-viewer-open-wrapper" + (this.state.deckviewer ? " open" : "")}>
          <div className="deck-viewer-open info-viewer-open" onClick={() => this.setState({deckviewer: this.state.deckviewer ? null : this.state.model.deck, deckvieweredit: this.state.deckviewer ? false : true})}>
            <Img src="/images/card.png"/>
          </div>
        </div>
        {/*<Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "deck-viewer-open" && !this.state.deckviewer} target="deck-viewer-open" toggle={() => this.toggleTooltip("deck-viewer-open")}><b>Deck viewer</b><br/>Cards your deck starts with every fight.</Tooltip>*/}
        <div id="exp-bar" className={"exp-bar-wrapper" + (this.state.model.champion.level >= this.state.model.champion.maxLevel ? " overflow" : "") + (this.state.model.champion.expbar >= this.state.model.champion.threshold || this.state.model.levelingUp ? " levelup" : "")}>
          <div className="exp-bar-text">
            {
              this.state.model.champion.level >= this.state.model.champion.maxLevel
              ? <span className="exp-bar-maxlevel-label">
                  {read('scene/maxlevel')}
                  {
                    (this.state.model.champion.overflowExp || 0) > 0 &&
                    <span className="exp-overflow-text">{"+" + this.state.model.champion.overflowExp}</span>
                  }
                </span> : (
                this.state.model.champion.expbar >= this.state.model.champion.threshold || this.state.model.levelingUp
                ? read('scene/levelup')
                : this.state.model.champion.expbar + "/" + this.state.model.champion.threshold
              )
            }
          </div>
          {/*
            this.state.model.champion.onLevelBreak && this.state.model.champion.level < this.state.model.champion.maxLevel &&
            <div>
              <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "exp-bar-levelbreak"} target="exp-bar-levelbreak" toggle={() => this.toggleTooltip("exp-bar-levelbreak")}>{read('scene/levelbreakinfo')}</Tooltip>
              <div id="exp-bar-levelbreak" className="exp-bar-subtext">{read('scene/levelbreak')}</div>
            </div>
          */}
          <div className={"exp-bar"} onPointerDown={e => this.toggleTooltip("exp-bar", e.pointerType === "touch")}>
            {/*<div className="exp-bar-fill" style={{width: (this.state.model.levelingUp ? 100 : (100 * this.state.model.champion.expbar / this.state.model.champion.threshold)) + "%"}}/>*/}
          {[...Array(10)].map((_, i) => {
            let totalSegments = 10;
            let { expbar, threshold } = this.state.model.champion;
            if (this.state.model.champion.level >= this.state.model.champion.maxLevel)
              expbar = threshold;
            let expPerSegment = threshold / totalSegments;
            // Calculate how much EXP falls into this segment
            let segmentStart = i * expPerSegment;
            let segmentEnd = (i + 1) * expPerSegment;
            let expInSegment = Math.max(0, Math.min(expbar - segmentStart, expPerSegment));
            let fillPercent = (expInSegment / expPerSegment) * 100;

            return (
              <div key={i} className="exp-segment">
                <div 
                  className="exp-segment-fill" 
                  style={{ width: fillPercent + '%' }}
                />
              </div>
            );
          })}
          </div>
        </div>
        <div className="resources-info">
          {/*<div id="removes" onPointerDown={e => this.toggleTooltip("removes", e.pointerType === "touch")} className="champion-stat removes">
            <Img src="/images/remove.png"/>
            <div className="stat-count">{this.state.model.removes}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "removes"} target="removes" toggle={() => this.toggleTooltip("removes")}><b>Whispers</b><br/>Allows you to remove a card after a card choice or skip a card choice.</Tooltip>
          */}{/*<div id="arousal" onPointerDown={e => this.toggleTooltip("arousal", e.pointerType === "touch")} className="champion-stat arousal">
            <Img src="/images/arousal.png"/>
            <div className="stat-count">{this.state.model.champion.arousal}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "arousal"} target="arousal" toggle={() => this.toggleTooltip("arousal")}><b>{read('scene/arousal')}</b><br/>{read('scene/arousalinfo')}</Tooltip>
          */}{/*<div id="insight" onPointerDown={e => this.toggleTooltip("insight", e.pointerType === "touch")} className="champion-stat insight">
            <Img src="/images/insight.png"/>
            <div className="stat-count">{this.state.model.insight}</div>
          </div>
          <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "insight"} target="insight" toggle={() => this.toggleTooltip("insight")}><b>{read('scene/insight')}</b><br/>{read('scene/insightinfo')}</Tooltip>*/}
          { 
            this.state.model.paws > 0 &&
            <div><div id="paws" onPointerDown={e => this.toggleTooltip("paws", e.pointerType === "touch")} className="champion-stat paws">
              <div>{Array.from({ length: this.state.model.paws }, (_, index) =>
                <Img style={{zIndex: this.state.model.paws-index}} key={"paw-" + index} src="/images/paws.png"/>
                )}</div>
            </div>
            <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "paws"} target="paws" toggle={() => this.toggleTooltip("paws")}><b>{read('scene/paws')}</b><br/>{read('scene/pawsinfo')}</Tooltip>
            </div>
          }
          {
            this.state.model.keys > 0 &&
            <div><div id="keys" onPointerDown={e => this.toggleTooltip("keys", e.pointerType === "touch")} className="champion-stat keys">
              <div>{Array.from({ length: this.state.model.keys }, (_, index) =>
                <Img style={{zIndex: this.state.model.keys-index}} key={"key-" + index} src="/images/key.png"/>
                )}</div>
            </div>
            <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "keys"} target="keys" toggle={() => this.toggleTooltip("keys")}><b>{read('scene/keys')}</b><br/>{read('scene/keysinfo')}</Tooltip>
            </div>
          }
        </div>
        <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "expbar"} target="exp-bar" toggle={() => this.toggleTooltip("expbar")}><b>{read('scene/expbar')}</b><br/>{this.state.model.champion.level >= this.state.model.champion.maxLevel ? read('scene/overflowexpinfo') : read('scene/expbarinfo')}</Tooltip>
        
        <div className="scene-item-list">
        {
          [...Array(this.state.model.champion.potionSlots + (this.state.model.champion.potions[this.state.model.champion.potionSlots] ? 1 : 0)).keys()].map(n => this.state.model.champion.potions[n]).map((item,i) =>
            <div key={"item-item-" + i} className="scene-item">
              { i < this.state.model.champion.potionSlots ? <Img className="item-placeholder" key={"item-" + i + "-placeholder"} src="/images/item.png"/> : "" }
              {
                item ?
                <div className="potion-action-wrapper">
              <div id={"item-" + i} className={"inner-item scene-item selectable" + (this.state.potionActionTouch === i && this.state.tooltip === "item-" + i ? " potion-selected" : "") + (this.isPotionUsable(item) ? (" usable" + (["fountain", "activefountain", "mezurishop", "shop", "menagerie", "relic", "cardchoice"].some(req => item[req]) ? " special-item" : "")) : "")} onPointerDown={e => {
                    const touch = e.pointerType === "touch";
                    if (touch)
                      this.toggleTooltip("item-" + i, true);
                    this.setState({
                      potionAction: touch || this.state.potionAction === i ? null : i,
                      potionActionTouch: touch ? i : null
                    });
                  }}>
                    <Img key={"item-" + i + "-" + item.img} src={item.img}/>
                  </div>
                  <Tooltip className="tooltip" placement="bottom" autohide={this.state.potionActionTouch !== i} isOpen={item && this.state.tooltip === "item-" + i} target={"item-" + i} toggle={() => this.toggleTooltip("item-" + i)}>
                  <b>{ item.name }</b><br/>
                  { tooltipEffect(item.effect) }
                  {
                    this.state.potionActionTouch === i &&
                    <div className="potion-action-buttons">
                      <button
                        type="button"
                        className="tooltip-button"
                        disabled={!this.isPotionUsable(item)}
                        onClick={() => this.run.champion.usePotion(i)}
                      >
                        Drink
                      </button>
                      <button type="button" className="tooltip-button" onClick={() => this.run.champion.dropPotion(i)}>Discard</button>
                    </div>
                  }
                  </Tooltip>
                  {
                    this.state.potionAction === i &&
                    <div className="potion-action-menu">
                      <button
                        type="button"
                        disabled={!this.isPotionUsable(item)}
                        onClick={() => this.run.champion.usePotion(i)}
                      >
                        Drink
                      </button>
                      <button type="button" onClick={() => this.run.champion.dropPotion(i)}>Discard</button>
                    </div>
                  }
                </div> : ""
              }
            </div>
          )
        }
        </div>
        <div className="scene-item-list scene-relic-list" style={{left: "calc(2.75vw + " + (this.state.model.champion.potionSlots * 6) + "vh)"}}>
        {
          this.state.model.champion.relics.map((relic,i) =>
            <div key={"relic-" + i} className="scene-item">
              {/*<Img className="item-placeholder" key={"relic-" + i + "-placeholder"} src="/images/relic.png"/>*/}
              {
                relic ?
                <div id={"relic-" + i} onPointerDown={e => this.toggleTooltip("relic-" + i, e.pointerType === "touch")} className={"inner-item scene-item" + (this.state.model.droppingRelic ? " usable" : "") + (this.isRelicActive(relic) ? "" : " inactive-relic")} onClick={() => { if (this.state.model.droppingRelic) this.run.champion.dropRelic(i); } }>
                  <Img key={"relic-" + i + "-" + relic.img} src={relic.img}/>
                  <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "relic-" + i} target={"relic-" + i} toggle={() => this.toggleTooltip("relic-" + i)}><b><img src="/images/relic.png"/>{ relic.name }</b><br/>{ tooltipEffect(relic.effect) }</Tooltip>
                </div> : ""
              }
            </div>
          )
        }
        </div>
        
      { this.state.model.room?.fight && this.state.model.room.fight.rewarding ? <Reward src={this.state.model.room.fight} collect={i => this.run.room.fight.collect(i)} collectCard={i => this.run.room.fight.collectCard(i)} cleanup={() => { this.run.room.fight.collect(0); }}/> : "" }
      {
        this.state.model.room && <Room plan={this.run.plan} src={this.state.model.room} manager={this}/>
      }
      {
        this.state.model.droppingPotion ?
        <div className="inventory-drop-text">
          {read('scene/usepotion')}
        </div> : ""
      }
      {
        this.state.model.campfireChoices ?
        <Campfire src={this.state.model} choices={this.state.model.campfireChoices} onSelect={choice => this.run.chooseCampfire(choice)}/> : ""
      }
      {
        this.state.model.pathChoices ?
        <Campfire src={this.state.model} choices={this.state.model.pathChoices} onSelect={choice => this.run.choosePath(choice)}/> : ""
      }
      { this.state.model.choosingCard && !this.state.model.levelingUp ?
        <div className="fight-loot-card lightbox-container">
          <div className="lightbox-inner">
            <CardSelector
              run={this.run}
              level={this.state.model.champion.level}
              text={this.state.model.bundle ? "Accept" : (this.state.model.reroll ? "Reroll" : "Skip")}
              options={this.state.model.options}
              onFocus={model => this.setState({tooltip: null, focus: model})}
              onSelect={this.state.model.bundle ? () => {} : i => this.run.collectCard(i)}
              onSkip={this.run.deckbuilder ? undefined : () => this.run.skipChoice()}
              />
          </div>
        </div> : ""
      }
      {
        <LevelUp champion={this.state.model.champion}/>
      }
      {
        this.state.model.droppingCard || this.state.model.duplicatingCard ?
        <div className={"scene-deckviewer" + (this.state.deckvieweredit ? " edit" : "")}>
          <div id="deckviewer-deck-size" className={"progress-run-date"}>{this.state.model.droppingCard ? read('scene/dropone') : read('scene/duplicateone')}</div>
          <DeckViewer
            onSelect={this.state.model.droppingCard ? i => {} : i => this.run.duplicateCard(i)}
            info={true}
            run={this.state.model}
            level={this.state.model.champion.level}
            deck={this.state.model.deck}
            onClose={() => {}}/>
        </div> : ""
      }
      {
        this.state.mapviewer ?
        <MapViewer setPlan={plan => this.run.setPlan(plan)} run={this.run} map={this.state.model.map} onClose={() => this.setState({mapviewer: false})}/> : ""
      }
      {
        this.state.deckviewer &&
        <div className={"scene-deckviewer" + (this.state.deckvieweredit ? " edit" : "")}>
          { this.state.deckvieweredit && <div className="deck-management-info">
            <div id="deckviewer-deck-size" className={"deck-size progress-run-date" + (this.state.model.deckSize < this.state.model.minDeckSize ? " red" : "")}>{read('scene/decksize') + ": " + this.state.model.deckSize}</div>
            <div id="deckviewer-entropy" onPointerDown={e => this.toggleTooltip("deckviewer-entropy", e.pointerType === "touch")} className="deck-management-entropy">
              <Img src="/images/entropy.png"/>
              <span>{this.state.model.minDeckSize}</span>
            </div>
          </div> }
          { this.state.deckvieweredit && <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "deckviewer-deck-size"} target="deckviewer-deck-size" toggle={() => this.toggleTooltip("deckviewer-deck-size")}>{read('scene/decksizeinfo')}</Tooltip> }
          { this.state.deckvieweredit && <Tooltip className="tooltip" placement="bottom" isOpen={this.state.tooltip === "deckviewer-entropy"} target="deckviewer-entropy" toggle={() => this.toggleTooltip("deckviewer-entropy")}><b>{read('scene/entropy')}</b><br/>{read('scene/entropyinfo')}</Tooltip> }
          <DeckViewer
            onSelect={this.state.deckvieweredit && !this.state.storyEvent ? (i => this.run.switchEnableCard(i)) : null}
            info={this.state.deckvieweredit && !this.state.storyEvent}
            run={this.state.model}
            level={this.state.model.champion.level}
            deck={this.state.deckviewer}
            onClose={() => { if (this.run.canCloseDeckbuilder) this.setState({deckviewer: null, deckvieweredit: false}) }}/>
        </div>
      }
      {
        this.state.focus ? <CardBox src={this.state.focus} open={true} onClose={() => this.setState({focus:null})}/> : ""
      }
      {
        !this.state.unlocks && (this.state.model.over || this.state.model.win) ?
        <div className={"game-over" + (this.state.model.win ? " game-over-win" : "")}>
          <h2>{ this.state.model.win ? read('scene/victory') : read('scene/gameover')}</h2>
          <div className="game-over-quote">
            {(() => {
              if (this.state.model.win) {
                if (this.run.storyEvent && this.run.memory)
                  return (
                    <div>
                      <span>Leave the past to the past.</span>
                      <span>You are more, and will be more.</span>
                    </div>
                  );
                else if (this.run.storyEvent && (this.run.champion.level >= this.run.champion.model.levelLimitPremium)) // Win the last story event
                  return (
                    <div>
                      <span>{read('scene/endruncontentlimit1')}</span>
                      <span>{read('scene/endruncontentlimit2')}</span>
                    </div>
                  );
                else if (this.run.storyEvent && !premium && (this.run.champion.maxLevel >= this.run.champion.model.levelLimit)) // Win the last story event for the public version
                  return (
                    <div>
                      <span>{read('scene/endrunpubliclimit1')}</span>
                      <span>{read('scene/endrunpubliclimit2')}</span>
                      <span className="patreon-redirect" onClick={() => window.open("https://www.patreon.com/NeiNalen", '_blank')}>Get now on Patreon</span>
                    </div>
                  );
                else if (this.run.storyEvent) // Win a story event with further content ahead
                  return (
                    <div>
                      <span>{read('scene/endrunstory1')}</span>
                      <span>{read('scene/endrunstory2')}</span>
                    </div>
                  );
                else if (this.run.floor < 4) // Unlocking a key
                  return (
                    <div>
                      <span>{read('scene/endrunkey1')}</span>
                      <span>{read('scene/endrunkey2')}</span>
                    </div>
                  );
                else if ((this.run.champion.model.key !== 5) && this.run.power === 1)
                  return (
                    <div>
                      <span>{read('scene/endrunpower1')}</span>
                      <span>{read('scene/endrunpower2')}</span>
                    </div>
                  );
                else // Going to the end of the maze 
                  return (
                    <div>
                      <span>{read('scene/endrunpowerlimit1')}</span>
                      <span>{read('scene/endrunpowerlimit2')}</span>
                    </div>
                  );
              } else { // Loss
                return (
                  <div>
                    <span>{read('scene/endrungameover1')}</span>
                    <span>{read('scene/endrungameover2')}</span>
                  </div>
                );
              }
            })()}
          </div>
          <div className="game-over-recap">
            <div className="game-over-champion">{ this.state.model.champion.model.name }</div>
            <div className="game-over-stats">
              <div className="game-over-stat">
                <div className="game-over-stat-name">{read('scene/level')}</div><div className="game-over-stat-value">{ this.run.stats.level }</div>
              </div>
              {/*<div className="game-over-stat">
                <div className="game-over-stat-name">Rooms cleared</div><div className="game-over-stat-value">{ this.run.stats.roomsCleared }</div>
              </div>
              <div className="game-over-stat">
                <div className="game-over-stat-name">Bosses slain</div><div className="game-over-stat-value">{ this.run.stats.bossesSlain }</div>
              </div>*/}
              {
                this.run.convertedExpReward > 0 &&
                <div className="game-over-stat">
                  <div className="game-over-stat-name">{read('scene/resultshards')}</div><div className="game-over-stat-value"><img className="game-over-runes-icon" src="/images/soulshard.png"/>{ this.run.convertedExpReward }</div>
                </div>
              }
            </div>
          </div>
          <div>{ this.run.zen && this.run.over && <MainButton onClick={() => this.run.continue()}>{read('scene/continue')}</MainButton> }<MainButton to="/play">{read('scene/mainmenu')}</MainButton></div>
          
        </div> : ""
      }
      {
        this.state.unlocks &&
      <div className="scene-unlock">
        <div className="lightbox-container" onClick={() => {
            if (!this.canSelectUnlock)
              return;
            let unlocks = this.state.unlocks.slice();
            if (unlocks.length <= 1)
              this.setState({unlocks: undefined, unlockImageIndex: null});
            else {
              unlocks.shift();
              this.setState({unlocks: unlocks, unlockImageIndex: null});
            }
          }}>
          <div className="lightbox-inner">
            {
              (() => {
                const unlock = this.state.unlocks[0];
                const milestone = unlock.type === "milestone" ? unlock.milestone : null;
                const imageIndexes = milestone ? this.getUnlockedMilestoneImageIndexes(milestone) : [];
                const imageIndex = milestone ? (imageIndexes.includes(this.state.unlockImageIndex) ? this.state.unlockImageIndex : this.getMilestoneImageIndex(milestone)) : null;
                const nextImageIndex = this.getNextMilestoneImageIndex(imageIndexes, imageIndex);
                const img = milestone ? this.getMilestoneImage(milestone, imageIndex) : unlock.img;
                const difficulty = milestone ? this.getMilestoneDifficulty(milestone, imageIndex) : null;
                const reward = milestone ? milestone.reward : null;
                const zenImage = milestone && this.isZenMilestoneImage(milestone, imageIndex);
                const hideImage = false;

                return (
                  <div className={"scene-unlock-inner unlock-" + unlock.type + (hideImage ? " no-image" : "")}>
                    <div className={"scene-unlock-text" + (difficulty ? " has-difficulty" : "")}>{unlock.text}</div>
                    { difficulty && <div className={"scene-unlock-difficulty " + difficulty + "-difficulty"}>{this.getDifficultyName(difficulty)}</div> }
                    { reward && <div className="scene-unlock-reward-wrapper">
                      <div className="scene-unlock-reward-label">Reward</div>
                      <div className="scene-unlock-reward">{reward}</div>
                    </div> }
                    { unlock.premium && <div className="scene-unlock-subtext">{read('nav/soonpublic')}</div> }
                    { unlock.premium && <div className="patreon-redirect" onClick={() => window.open("https://www.patreon.com/NeiNalen", '_blank')}>{read('nav/getnowonpatreon')}</div> }
                    {
                    unlock.type === "card" ?
                    <div className="scene-unlock-card">
                      <Card key={"unlock-" + unlock.card.key} src={unlock.card}/>
                    </div>
                    :
                    hideImage ? "" :
                    <div className={"scene-unlock-img" + (zenImage ? " zen-milestone" : "")}>
                      {
                        difficulty && nextImageIndex !== null ?
                        <div className="scene-unlock-difficulty-art-switch" onClick={e => { e.stopPropagation(); this.setState({unlockImageIndex: nextImageIndex}); }}>
                          <Img alt="" src={"/images/" + difficulty + ".png"}/>
                        </div> : ""
                      }
                      { img ? <Img key={"unlock-" + img} src={img}/> : <div className="scene-unlock-blank"/> }
                      { zenImage && <div className="scene-unlock-zen-requirement">{milestone.requirement}</div> }
                    </div>
                    }
                  </div>
                );
              })()
            }
          </div>
        </div>
      </div>
      }
      <div className="lightbox-container time-down">
        <div className="lightbox-inner">
          <Img className="time-down-img" src="/images/time.png"/>
        </div>
      </div>
      {
        this.state.cutscene ?
        <Cutscene instant={this.cutsceneManager.intro} back={() => this.cutsceneManager.back()} skip={() => this.cutsceneManager.skip()} continue={() => this.cutsceneManager.continue()} src={this.state.cutscene}/> : ""
      }
      </div>
		);
	}
}
